<template>
  <div class="p-home">
    <div class="p-home-content">
      <daily-schedule normalSize="long"></daily-schedule>
    </div>
  </div>
</template>
<script>

import DailySchedule from '../components/dailySchedule/dailySchedule'
import indexService from '../service/index'
export default {
  name: 'dHomeView',
  components: {
    DailySchedule
  },
  data () {
    return {
      userType: '',
      officetype: '', // 平台版还是团队版
      hasPermissionForTools: false // 工具大数据权限
    }
  },
  mounted () {
    this.initStatus()
    // 获取是否有大数据搜索权限
    this.getToolsPermissionForBigData()
  },
  methods: {
    initStatus () {
      this.userType = localStorage.getItem('userType')
      this.officetype = localStorage.getItem('officetype')
    },
    async getToolsPermissionForBigData () {
      let response = null
      response = await indexService.getToolsPermissionForBigData()
      if (response.isSuccess) {
        this.hasPermissionForTools = response.data
      } else {
        this.$message(response.resultMsg)
      }
    }
  }
}
</script>
<style lang="stylus">
.p-home
  display flex
  // 为了iframe不出横向滚动条，这里不需要设置宽度
  // width 1000px
  // margin 0 auto
  flex-direction row
  &-content
    flex 1
  &-sidebar
    width 280px
    // width 330px
    border-left 1px solid #ECECEC
  &-content,
  &-sidebar
    &>div
      border-top 1px solid #ECECEC
      &:first-child
        border-top 0
</style>
